import twinFields from './twinFields';
const {
  getDefinitions: getTwinFields
} = twinFields;
import apiService from '@/services/apiService/dashboards';
import debounce from 'lodash/debounce';
import { mapState } from 'vuex';
import draggable from 'vuedraggable';
import get from 'lodash/get';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'TwinAttributesSelector',
  components: {
    draggable
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    twins: {
      type: Array,
      required: true
    },
    twinFilter: {
      type: Object,
      required: true
    },
    virtualDeviceFilter: {
      type: Object,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    },
    appendIcon: {
      type: [Function, String],
      required: false,
      default: null
    }
  },
  data() {
    return {
      isFetchingAvailableStates: true,
      availableStates: []
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    twinFields() {
      return getTwinFields(this.$t, this.twins);
    },
    itemsForAttributesSelectInput() {
      const staticAttributes = Object.entries(this.twinFields).map(([key, value]) => ({
        text: get(value, 'defaultLabel'),
        value: key
      }));
      const stateAttributes = this.availableStates.filter((state, index, self) => self.findIndex(s => s.key === state.key) === index).map(state => ({
        text: this.$t('Dashboards.twinFields.defaultLabel.state', {
          state: state.key
        }),
        value: `state.${state.key}`
      })).sort((a, b) => {
        return a.text.localeCompare(b.text);
      });
      return [...staticAttributes, ...stateAttributes];
    },
    attributes: {
      get() {
        const attributes = Array.isArray(this.value) ? this.value : [];
        return attributes.map(attribute => attribute.property);
      },
      set(newSelectedAttributes) {
        const newAttributes = [];
        const currentAttributes = cloneDeep(Array.isArray(this.value) ? this.value : []);
        newSelectedAttributes.forEach(attribute => {
          let definition = currentAttributes.find(item => item.property === attribute);
          if (!definition) {
            definition = {
              property: attribute,
              label: ''
            };
          }
          newAttributes.push(definition);
        });
        this.$emit('input', newAttributes);
      }
    }
  },
  watch: {
    twinFilter: {
      async handler() {
        this.fetchAvailableStates();
      },
      immediate: true
    },
    virtualDeviceFilter: {
      async handler() {
        this.fetchAvailableStates();
      },
      immediate: true
    }
  },
  methods: {
    get(obj, key, defaultValue) {
      return get(obj, key, defaultValue);
    },
    fetchAvailableStates: debounce(function () {
      this.isFetchingAvailableStates = true;
      this.actuallyFetchAvailableStates();
    }, 500),
    async actuallyFetchAvailableStates() {
      try {
        this.isFetchingAvailableStates = true;
        const result = await apiService.fetchAvailableStatesForDashboardFilter(this.dashboardId, this.twinFilter, this.virtualDeviceFilter, this.customParameters);
        this.availableStates = result;
      } catch (e) {
        this.$snack(this.$t('Dashboards.components.widgetTwinTableOptionsEditor.snack.error.couldNotFetchAvailableStates', {
          error: e.message
        }), 'error');
        console.error(e);
      } finally {
        this.isFetchingAvailableStates = false;
      }
    },
    removeAttribute(index) {
      this.attributes = this.attributes.filter((_, i) => i !== index);
    },
    setProperty(index, property, value) {
      const clone = cloneDeep(this.value);
      if (property === 'label') {
        value = value || '';
      }
      set(clone, `[${index}]${property}`, value);
      this.$emit('input', clone);
    },
    getProperty(index, property, defaultValue) {
      return get(this.value, `[${index}]${property}`, defaultValue);
    }
  }
};